import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__getCompareResult = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(cars_ids) {
    var _res$data, postIds, url, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          postIds = cars_ids.map(function (id, idx) {
            return "postId".concat(idx + 1, "=").concat(id);
          }).join("&");
          url = "/car-comparison?".concat(postIds);
          console.log(url);
          _context.n = 1;
          return fetcher().get(url);
        case 1:
          res = _context.v;
          return _context.a(2, res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data);
        case 2:
          _context.p = 2;
          _t = _context.v;
          console.error(_t);
          return _context.a(2, null);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function api__getCompareResult(_x) {
    return _ref.apply(this, arguments);
  };
}();